import { Box, Button, Divider, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import ReactQuill from 'react-quill';
import { useSelector, useDispatch } from 'react-redux'
import {useNavigate} from 'react-router-dom'
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";



    function DentelContent() {
        const navigate = useNavigate()
        const dispatch = useDispatch()
        const allLanguages = useSelector((state) => state.language.languageList)

        const [loading, setLoading] = useState(false)

        const modules = {
            toolbar: [
              ["bold", "italic", "underline"], // toggled buttons
              [{ list: "ordered" }, { list: "bullet" }],
              ["link"], // superscript/subscript
            ],
          };

        const [aboutUsData, setAboutUsData] = useState([])

        const [activeLanguages, setActiveLanguages] = useState(allLanguages);
   
        const [aboutUsId, setAboutUsId] = useState('')

        const [heading, setHeading] = useState({ en: { heading: '' } });
        const [headerImage, setHeaderImage] = useState({})
        const [description, setDescription] = useState({en : {line1 : '', line2 : '', line3 : '', line4 : ''}})
       
       
        
        const handleHeadingChange = (e, lang) => {
            setHeading(prev => ({
                ...prev,
                [lang]: { heading: e.target.value }
            }));
        };


        const handleDescriptionChange = (value, lang, line) => {
            setDescription(prev => ({
              ...prev,
              [lang]: {
                ...prev[lang],
                [line]: value,
              },
            }));
          };
          

        const handleHeaderImageChange = (e) => {
            const file = e.target.files[0];
            if (file && file.type.startsWith('image/')) {
                console.log('Selected image:', file);
                setHeaderImage(file)
            } else {
                alert('Please select a valid image file (e.g., .jpg, .png, .gif)');
            }
        };
        

        const handleSubmit = async () => {
            if(aboutUsData?.length > 0){
                handleSubmitEdit()
            }else{
                const formData = new FormData();

                // Append form data
                formData.append('header', JSON.stringify(heading));
                formData.append('description', JSON.stringify(description));
    
                formData.append('header_image', headerImage)
                
                
                
                setLoading(true)
                try {
                    const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}add-dental-content`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                      })
                    console.log(response)
                    if(response.status === 201){
                        console.log(response.data)
                        setLoading(false)
                    }
                } catch (error) {
                    console.log(error)
                    if(error.response.status === 401 || error.response.status === 403){
                        navigate('/Admin/login')
                        dispatch(removeData())
                    }
                    setLoading(false)
                }
            }
        }

        const getAboutUs = async () => {
            try {
                const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-dental-content`)
                setAboutUsData(response?.data?.data)
            } catch (error) {
                console.log(error)
                if(error.response.status === 401 || error.response.status === 403){
                    navigate('/Admin/login')
                    dispatch(removeData())
                }
            }
        }

        useEffect(() => {
            getAboutUs()
        }, [])


        useEffect(() => {
            if(aboutUsData?.length > 0){
                setHeading(aboutUsData?.[0]?.header)
                setDescription(aboutUsData?.[0]?.description)
                setAboutUsId(aboutUsData?.[0]?._id)
                setHeaderImage(`${process.env.REACT_APP_FILE_PATH}/${aboutUsData?.[0]?.images?.header_image}`)
            }
        }, [aboutUsData])
        console.log(aboutUsData.length)

        const handleRemoveHeaderImage = () => {
            setHeaderImage({})
        }

        const updateAboutUs = async (id, formData) => {
            setLoading(true)
            try {
              const response = await axiosInstance.put(`${process.env.REACT_APP_API_URL}edit-dental-content/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
              });
              console.log('AboutUs updated successfully:', response);
              getAboutUs()
              setLoading(false)
            } catch (error) {
              console.error('Error updating AboutUs:', error);
              if(error.response.status === 401 || error.response.status === 403){
                navigate('/Admin/login')
                dispatch(removeData())
            }
            setLoading(false)
            }
          };

          
          const handleSubmitEdit = async () => {
            const formData = new FormData();
          
            // Append fields (conditionally if updated)
            formData.append('header', JSON.stringify(heading));
            formData.append('description', JSON.stringify(description));
           
            if (headerImage instanceof File) {
                formData.append('header_image', headerImage);
            }            

          
          
            await updateAboutUs(aboutUsId, formData);
          };


          if(loading){
              return <p>Loading...</p>
          }

          
          

        return (
            <Box>
                <Box>
                <Typography sx={{ fontSize: '1.4rem', fontWeight: 700 }}>Heading</Typography>
                
                <Typography sx={{mt : 2, mb : 1}}>Header Image</Typography>
                {headerImage?.length > 0 ? (
                    <Box sx={{display : 'flex', alignItems : 'center', position : 'relative'}}>
                    <Box component='img' sx={{width : '100px', height : '100px'}} src={headerImage} alt='headerimage' />
                    <span onClick={() => handleRemoveHeaderImage()} className='bg-red-600 cursor-pointer text-white font-bold absolute top-[-12px] left-[5rem] p-1 px-3 rounded-full'>X</span>
                    </Box>
                ) : (
                    <TextField type='file' onChange={handleHeaderImageChange} />
                )}
               
                {activeLanguages.map((lang) => (
                    <Box key={lang.value} sx={{ display: 'flex', gap: 5, justifyContent : 'center',alignItems: 'center', mt: 2 }}>
                        <Typography sx={{width : '20%', color : 'black'}}>
                                {lang.name}
                        </Typography>

                        <TextField
                            value={heading[lang.value]?.heading || ''}
                            onChange={(e) => handleHeadingChange(e, lang.value)}
                            placeholder={`Enter heading for ${lang.name}`}
                        />
                    </Box>
                ))}

                
                </Box>
                
                <Divider sx={{mt : 2, mb : 2}}/>
                
                <Typography sx={{ fontSize: '1.4rem', fontWeight: 700 }}>About</Typography>

                {activeLanguages.map((lang) => (
                    <Box key={lang.value} sx={{ display: 'flex', mb : 8,flexDirection : 'column', gap: 2, mt: 2 }}>
                        <Typography sx={{ color : 'black', fontWeight : 700, fontSize : '1.1rem'}}>
                                {lang.name}
                        </Typography>

                        <TextField
                            value={description[lang.value]?.line1 || ''}
                            onChange={(e) => handleDescriptionChange(e, lang.value, 'line1')}
                            placeholder={`Enter about heading ${lang.name}`}
                        />
                        

                     
                        <ReactQuill
                            style={{ height: "160px" }}
                            placeholder={`Enter description for about ${lang.name}`}
                            value={description[lang.value]?.line2 || ''}
                            onChange={(value) => handleDescriptionChange(value, lang.value, 'line2')}
                            modules={modules}
                            />

                         

                        {/* <TextField
                        rows={4}
                        multiline
                            value={description[lang.value]?.line2 || ''}
                            onChange={(e) => handleDescriptionChange(e, lang.value, 'line2')}
                            placeholder={`Enter description for about ${lang.name}`}
                        /> */}

                    </Box>
                ))}

            

            <Divider  sx={{mt : 2, mb : 2}} />

            <Typography sx={{ fontSize: '1.4rem', fontWeight: 700 }}>Appointment Details</Typography>

            {activeLanguages.map((lang) => (
                    <Box key={lang.value} sx={{ display: 'flex', mb : 8,flexDirection : 'column', gap: 2, mt: 2 }}>
                    <Typography sx={{ color : 'black', fontWeight : 700, fontSize : '1.1rem'}}>
                            {lang.name}
                    </Typography>

                    <TextField
                        value={description[lang.value]?.line3 || ''}
                        onChange={(e) => handleDescriptionChange(e, lang.value, 'line3')}
                        placeholder={`Enter Appointment Details heading ${lang.name}`}
                    />
                    

                    <ReactQuill
                            style={{ height: "160px" }}
                            placeholder={`Enter description for about ${lang.name}`}
                            value={description[lang.value]?.line4 || ''}
                            onChange={(value) => handleDescriptionChange(value, lang.value, 'line4')}
                            modules={modules}
                            />


                    {/* <TextField
                    rows={4}
                    multiline
                        value={description[lang.value]?.line4 || ''}
                        onChange={(e) => handleDescriptionChange(e, lang.value, 'line4')}
                        placeholder={`Enter description for about ${lang.name}`}
                    /> */}

                </Box>
                ))}

              
                <Box>
                <Button disabled={loading} variant="contained" onClick={() => handleSubmit()}  sx={{ mt: 2 }}>{aboutUsData?.length > 0 ? 'Update' : 'Save'}</Button>
                </Box>
            </Box>
        );
    }

    export default DentelContent;
